import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import {
  addDiscountAPICall,
  getDiscountAPICall
} from '../../../../API/Settings/Discount/discountAPI'
import '../../../../css/Settings/Discount/discountSettings.css'
import ErrorSnackbar from '../../../Single Components/SnackBars/ErrorSnackbar'
import SuccessSnackbar from '../../../Single Components/SnackBars/SuccessSnackbar'

export const Discount = () => {
  const discountData = useSelector((state) => state.discountSlice.value)
  const [discount, setDiscount] = useState('')
  const [showInPOS, setShowInPOS] = useState(false)
  const [isModify, setIsModify] = useState(false)

  // snackbar states
  const [successSnackbar, setSuccessSnackbar] = useState(false)
  const [errorSnackbar, setErrorSnackbar] = useState(false)
  const [snackMsg, setSnackMsg] = useState('Error!!')

  const updateListner = () => {
    setIsModify(!isModify)
  }

  const closeSuccessSnackbar = () => {
    setSuccessSnackbar(false)
  }

  const closeErrorSnackbar = () => {
    setErrorSnackbar(false)
  }

  const getDiscount = (e) => {
    setDiscount(e.target.value)
  }

  const handleShowInPOSChange = (e) => {
    setShowInPOS(e.target.checked)
  }

  const submitBtnFunction = () => {
    addDiscountAPICall(
      {
        discountAmount: parseFloat(discount),
        showinPos: showInPOS
      },
      updateListner,
      setSuccessSnackbar,
      setErrorSnackbar,
      setSnackMsg,
      setDiscount,
      setShowInPOS
    )
  }


  useEffect(() => {
    getDiscountAPICall()
     
    
  }, [])
  useEffect(() => {
  if (discountData) {
    // if (discountData.discountAmount !== null && discountData.discountAmount !== undefined) {
    //   setDiscount(discountData.discountAmount)
    // } else {
    //   setDiscount('')
    // }

    if (discountData.showinPos !== undefined) {
      setShowInPOS(discountData.showinPos)
    }
  }
}, [discountData])


  // useEffect(() => {
  //   getDiscountAPICall().then((data) => {
  //     console.log(data);
      
  //     if (data?.discountAmount !== undefined) {
  //       setDiscount(data.discountAmount)
  //     }
  //     if (data?.showinPos !== undefined) {
  //       setShowInPOS(data.showinPos)
  //     }
  //   })
  // }, [isModify])

  return (
    <div>
      <div className="discount-settings-container">
        <div className="discount-settings-container-body">
          <div className="discount-settings-container-body-section">
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <p>Discount Amount</p>
              <label style={{ display: 'flex', alignItems: 'center', gap: '5px',width:"125px" }}>
                Show In POS
                <input 
                style={{width:"15%"}}
                  type="checkbox"
                  checked={showInPOS}
                  onChange={handleShowInPOSChange}
                />
              </label>
            </div>
            <input type="number" value={discount} onChange={getDiscount} />
            <p className="discount-settings-container-body-section-percentage">
              Discount : {discountData?.discountAmount}%
            </p>
          </div>

          <div className="discount-settings-container-button">
            <button onClick={submitBtnFunction} className="btn btn-primary">
              Submit
            </button>
          </div>
        </div>
      </div>

      <SuccessSnackbar
        open={successSnackbar}
        handleClose={closeSuccessSnackbar}
        message={snackMsg}
      />

      <ErrorSnackbar
        open={errorSnackbar}
        handleClose={closeErrorSnackbar}
        message={snackMsg}
      />
    </div>
  )
}
